import configureStore from "../../store/configureStore";
import { join } from "path";
//https://aymvqol5ch.execute-api.us-east-1.amazonaws.com/default/genPdfB64

export default function dbGetStatement(templatID, jsonData) {
  console.log("about to do a fetch with this: ||" + JSON.stringify(jsonData));
  return dispatch => {
    // const state = configureStore.getState();
    // let fbDbUrl = state.db.team.fbDbUrl;
    // let fbCloudUrl = state.db.team.fbCloudUrl;
    // let fetchQuery = "";

    let headersObj = {
      ["Content-Type"]: "application/json; charset=utf-8"
    };

    let fetchQuery =
      "https://oj9p2ekyv7.execute-api.us-east-1.amazonaws.com/default/generatepdf-dev-generatepdf";
    //console.log("getStatement URL: " + fetchQuery);

    return fetch(fetchQuery, {
      method: "POST",
      body: JSON.stringify({ template: templatID, data: jsonData }),
      headers: headersObj
    })
      .then(res => res.json())
      .then(parsedRes => {
        // console.log(
        //   "returning this from pdf genertor: " + JSON.stringify(parsedRes)
        // );
        return parsedRes;
      })
      .catch(err => {
        console.log("error occured: " + err);
        alert(
          "[RECS] dbGetId(" +
            targetTable +
            "). We are unable to complete your request at this time, please check your network connection or contact support[getRecord][" +
            err +
            "]"
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/Services/statements/dbGetStatement.js